module.exports = __webpack_public_path__ + "img/sign-20.05c96afe.jpg";